import { Component, OnInit, ViewChild, Output, EventEmitter, AfterViewInit, Input, ChangeDetectorRef } from '@angular/core';
import { Product } from 'src/app/modals/product.model';
import { ProductService } from 'src/app/components/shared/services/product.service';
import { ActivatedRoute, Params, Router, NavigationEnd } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material';
import { CartService } from 'src/app/components/shared/services/cart.service';
import { SwiperDirective, SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ProductZoomComponent } from './product-zoom/product-zoom.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedMethods } from 'src/app/components/shared/services/sharedMethods-service';
import { ScrollService } from 'src/app/components/shared/services/scroll.service';
import { filter, map, mergeMap } from 'rxjs/operators';
import { SEOService } from 'src/app/components/shared/services/seoservice';
import { plainToClass } from 'class-transformer';
import { AuthService } from 'src/app/components/auth/auth.service';
import { AuthGuard } from 'src/app/components/auth/auth-guard.service';
import { MatomoTracker } from '@codeculture/ngx-matomo';


@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent implements OnInit, AfterViewInit {

  public config: SwiperConfigInterface={};
  @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();

  @Input() productId: number;
  @Input() linkvideo: string;

  @ViewChild('zoomViewer', { static: true }) zoomViewer;
  @ViewChild(SwiperDirective, { static: true }) directiveRef: SwiperDirective;

  public product            :   Product = new Product();
  public products           :   Product[] = [];

  public image: any;
  public zoomImage: any;

  public counter            :   number = 1;

  index: number;
  bigProductImageIndex = 0;

  public infosbar = [];

  shareLinkBegining = '';

  @Output() dialogRef: MatDialogRef<ProductDetailsComponent>

  whatsappLink = '';

  player: YT.Player;
  savePlayer(player) {
    this.player = player;
    console.log('player instance', player);
    player.playVideo();
  }
  onStateChange(event) {
    console.log('player state', event.data);
  }

  // tslint:disable-next-line:max-line-length
  constructor(public authGuard: AuthGuard, public authService: AuthService, private cdRef:ChangeDetectorRef, private seoService: SEOService, private activatedRoute: ActivatedRoute, private scrollService: ScrollService, private spinner: NgxSpinnerService, public sharedMethods: SharedMethods, private route: ActivatedRoute, public productsService: ProductService, public dialog: MatDialog, private router: Router, private cartService: CartService, private matomoTracker: MatomoTracker) {



    // this.id = 'elCtvocTfe4';

    //console.log(this.sharedMethods.cacheLoading);


    if(this.sharedMethods.cacheSettings === undefined) {

      this.sharedMethods.getSettings().subscribe(setting => {
        console.log(setting);
        this.infosbar = setting.infosbar;
      });

    } else {

      this.infosbar = this.sharedMethods.cacheSettings.infosbar;

    }


   }


  ngOnInit() {

    

    if( this.productId === undefined) {

      this.route.params.subscribe(params => {

        const id = +params['id'];
        // alert(id);
        this.scrollService.scrollToTop();
        this.getProd(id);

      });

      this.route.queryParams.subscribe(queryparams => {
        
        // console.log(queryparams['linkvideo']);
        if( queryparams['dat'] !== undefined && queryparams['dat'] !== '') {
          
          const affilate = +queryparams['dat'];

          // on rassure que le visiteur n'a pas encore de parrain
          if(localStorage.getItem('parrain') === null || localStorage.getItem('parrain') === undefined || localStorage.getItem('parrain') === '')
          localStorage.setItem('parrain', affilate.toString());

          // sauvegarde de l'id
          this.cartService.idaffilate = affilate;

          // alert(id_parrain);
  
        }

        
  
      });

    } else {
      // const idprod = 21;
      this.getProd(this.productId);
    }

    this.productsService.closePopupEvent.subscribe(data => {

      if(this.dialogRef !== undefined)
      this.dialogRef.close();

    });


    /* this.spinner.show();

    setTimeout(() => {
      this.spinner.hide();
    }, 5000); */

    // this.productsService.getProducts().subscribe(product => this.products = product);


    // this.getRelatedProducts();
  }

  

  public getProd(idprod: number) {

    this.spinner.show();
    this.productsService.getOneProduit(idprod).subscribe(data => {
      console.log(data.prod);
      this.product = plainToClass(Product, data.prod as object);
      this.products =  data.prodcat as Product[];
      this.spinner.hide();
      this.seoUpdate();
      this.whatsappLink = this.generateWhatsappLink(this.product);

      // piwik analytic
      if(this.authService.token.user !== undefined)
      this.matomoTracker.setUserId(this.authService.token.user.name);

      this.matomoTracker.setDocumentTitle(this.product.name + ' | Optimum Digitale');

      

    }, err => {

      this.spinner.hide();
      this.sharedMethods.errorApiShow(err.error.code, err.error.message);

    })

    /* if( this.productsService.cacheProduct.length === 0) {

      this.spinner.show();
      this.productsService.getProducts().subscribe(products => {
        this.productsService.cacheProduct = products;
        this.product = this.productsService.cacheProduct.find((item: Product) => item.id === idprod);
        // tslint:disable-next-line:max-line-length
        this.products = this.productsService.getProductByCategory(this.productsService.cacheProduct, (this.product.category !== null) ? this.product.category.slug:null, this.product.id);
        this.seoUpdate();
        this.whatsappLink = this.generateWhatsappLink(this.product);
        this.spinner.hide();
      },
      err => {
        this.spinner.hide();
        this.sharedMethods.errorApiShow(err.error.code, err.error.message);
      })

    } else {

      // console.log(idprod);
      this.product = this.productsService.cacheProduct.find((item: Product) => item.id === idprod);
      this.seoUpdate();
      this.whatsappLink = this.generateWhatsappLink(this.product);
      // tslint:disable-next-line:max-line-length
      this.products = this.productsService.getProductByCategory(this.productsService.cacheProduct, (this.product.category !== null) ? this.product.category.slug:null, this.product.id);

    } */

  }

  generateWhatsappLink(prod: Product): string {

    // tslint:disable-next-line:max-line-length
    let tel = (this.sharedMethods.cacheLoading) ? this.sharedMethods.cacheLoading.settings.whatsapplinkcontact:'';
    if(tel && tel !== '')
    return 'https://api.whatsapp.com/send?phone=' + tel + '&text=*Optimum Digital* je suis intéressé par votre *' + this.product.name + '* de *' +  ((this.product.salePrice !== null && this.product.salePrice !== undefined) ? this.product.salePrice : this.product.price) + ' ' + this.productsService.currency +  '* Merci! *LIEN:* ' +  this.shareLinkBegining +  this.product.id + '/' + this.product.slug + '&source=&data=&app_absent=';
    else
    return '';
  }


  seoUpdate() {

    this.seoService.updateTitle(this.product.name + ' | Optimum Digitale');
    this.seoService.updateOgUrl(this.shareLinkBegining +  this.product.id + '/' + this.product.slug);
    // Updating Description tag dynamically with title
    // this.seoService.updateDescription(event['title'] + event['description']);
    this.seoService.updateDescription(this.product.name);

    console.log('SEO update');

    /* this.router.events.pipe(filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
     )
     .subscribe((event) => {
       this.seoService.updateTitle(event['title']);
       this.seoService.updateOgUrl(event['ogUrl']);
       // Updating Description tag dynamically with title
       this.seoService.updateDescription(event['title'] + event['description']);


       // Then configure your routes like
       // {
          // path: 'about',
          // component: AboutComponent,
          // data: {
            // title: 'About',
            // description:'Description Meta Tag Content',
            // ogUrl: 'your og url'
          // }
       // },

     }); */

  }


  ngAfterViewInit() {

    this.route.queryParams.subscribe(queryparams => {
      // console.log(queryparams['linkvideo']);
      if( queryparams['linkvideo'] !== undefined && queryparams['linkvideo'] !== '') {
        setTimeout(() => {
          this.linkvideo =  queryparams['linkvideo'];
        }, 500);
        // this.cdRef.detectChanges();
      }


    });


    this.config = {
      observer: true,
      slidesPerView: 3,
      spaceBetween: 10,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: false,
      preloadImages: false,
      lazy: true,
      breakpoints: {
        480: {
          slidesPerView: 1
        },
        740: {
          slidesPerView: 2,
        },
        960: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 3,
        },


      }
    }
  }


  public openProductDialog(product, bigProductImageIndex) {
    let dialogRef = this.dialog.open(ProductZoomComponent, {
      data: {product, index: bigProductImageIndex },
      panelClass: 'product-dialog',
    });
    dialogRef.afterClosed().subscribe(product => {
      if (product) {
        this.router.navigate(['/products', product.id, product.name]);
      }
    });
  }


  public selectImage(index) {
    console.log(this.product)
    console.log(index)
    this.bigProductImageIndex = index;
  }




public increment() {
  this.counter += 1;
}

public decrement() {
  if(this.counter >1){
     this.counter -= 1;
  }
}


  // Add to cart
  public addToCart(product: Product, quantity) {
    if (quantity == 0) return false;
    this.cartService.addToCart(product, parseInt(quantity));
  }

   // Add to cart
   public buyNow(product: Product, quantity) {
    if (quantity > 0) {
      this.cartService.addToCart(product,parseInt(quantity),);
      this.router.navigate(['/pages/checkout']);
    }
      
 }



 public onMouseMove(e){
  if(window.innerWidth >= 1280){
    var image, offsetX, offsetY, x, y, zoomer;
    image = e.currentTarget;
    offsetX = e.offsetX;
    offsetY = e.offsetY;
    x = offsetX/image.offsetWidth*100;
    y = offsetY/image.offsetHeight*100;
    zoomer = this.zoomViewer.nativeElement.children[0];
    if(zoomer){
      zoomer.style.backgroundPosition = x + '% ' + y + '%';
      zoomer.style.display = "block";
      zoomer.style.height = image.height + 'px';
      zoomer.style.width = image.width + 'px';
    }
  }
}

public onMouseLeave(event){
  this.zoomViewer.nativeElement.children[0].style.display = "none";
}

public openZoomViewer(){
  this.dialog.open(ProductZoomComponent, {
    data: this.zoomImage,
    panelClass: 'zoom-dialog'
  });
}

getVideoLink(product): string {

  if ( product.linkvideo !== null && product.linkvideo !== undefined ) {
    const tabDate = product.linkvideo.split('/');
    const tab = tabDate[3].split('?');
    return '?linkvideo=' + tab[0];
  } else {

    return '';

  }


}



close() {
  this.dialogRef.close();
}


/* To copy Text from Textbox */
copyInputMessage(inputElement){
  inputElement.select();
  document.execCommand('copy');
  inputElement.setSelectionRange(0, 0);
  this.sharedMethods.successApiShow('lien copié avec succès!');
}


}


